import { Separator } from '../separator'
import { Owner } from '../../models/polymer/Owner.model'
import { Occupier } from '../../models/polymer/Occupier.model'
import { P2TextDescription } from "react-bootstrap-common-script";
import useIsMobile from '../../hooks/use-is-mobile';
import MobileTableMobile, { MobileTableItemInterface } from '../mobile/mobile-table';
import { useMemo } from 'react';
import { MyInfoWithDOD } from '../../models/polymer/MyInfo.model';
import { StructureStatusEnum } from '../../models/enum/structure-status.enum';
import { convertRoleToStructureStatus } from '../../utils/form-helper';
import { display } from 'html2canvas/dist/types/css/property-descriptors/display';

interface HouseholdStructureTableProps{
  owners?:Owner[],
  occupiers?:Occupier[],
  
  incomingOwners?:Owner[],
  incomingOccupiers?:Occupier[],

  additionalRoles?:MyInfoWithDOD[],
  // isMopMet?:boolean;
  // hasOrDisposedProperty?: boolean;
  // setHasOrDisposedProperty?: (value: boolean) => void;
}

function HouseholdStructureTable({owners=[], occupiers=[], incomingOwners=[], incomingOccupiers=[], additionalRoles=[],...props}:HouseholdStructureTableProps) {

  const { isMobile } = useIsMobile();


  const hasExecutorAdministrator = useMemo(()=>{
    return additionalRoles.some(e=>{
      const roleStructureStatus = convertRoleToStructureStatus(e.role_name);
      return roleStructureStatus === StructureStatusEnum.executor || roleStructureStatus === StructureStatusEnum.administrator
    })
  },[additionalRoles])

  const executorAdministratorListing:MyInfoWithDOD[] = useMemo(()=>{
    let dataList:MyInfoWithDOD[] = [];
    if(hasExecutorAdministrator){
      additionalRoles.forEach(e=>{
        const roleStructureStatus = convertRoleToStructureStatus(e.role_name);
        if(roleStructureStatus === StructureStatusEnum.executor || roleStructureStatus === StructureStatusEnum.administrator){
          dataList.push(e);
        }
      })
    }
    return dataList;
  },[additionalRoles, hasExecutorAdministrator])

  const current_mobile_table_items = useMemo(()=>{
    let obj_items:MobileTableItemInterface[] = [
      { header:"Owners", contents: owners.map(e=>e.myinfo.name), placeholder:"You do not have any owner(s)" },
      { header:"Occupiers", contents: occupiers.map(e=>e.myinfo.name),  placeholder:"You do not have any occupier(s)" },
    ];

    if(hasExecutorAdministrator){
      obj_items.push({ header:"Executor/Administrator", contents: additionalRoles.map(additional_role => `${additional_role.name} (${additional_role.role_name})`),  placeholder:"" });
    }
    return obj_items;
  },[additionalRoles, hasExecutorAdministrator, occupiers, owners])

 
  const proposed_mobile_table_items = useMemo(()=>{
    let obj_items:MobileTableItemInterface[] = [
      { header:"Owners", contents: incomingOwners.map(e=>e.myinfo.name), placeholder:"You have not added any owner(s)" },
      { header:"Occupiers", contents: incomingOccupiers.map(e=>e.myinfo.name),  placeholder:"You have not added any occupier(s)" },
      
    ];

    if(hasExecutorAdministrator){
      obj_items.push({ header:"Executor/Administrator", contents: additionalRoles.map(additional_role => `${additional_role.name} (${additional_role.role_name})`),  placeholder:"" });
    }
    return obj_items;
  },[additionalRoles, hasExecutorAdministrator, incomingOccupiers, incomingOwners])




  return (
    <div style={{margin:"32px 0",}}>
      <div style={{marginBottom:8}}>
        <P2TextDescription title={<p style={{fontSize:20, margin:0, color: "#000000", fontWeight: "700"}}>Summary</p>} color='#000'/>
      </div>
      {!isMobile && <div className='ohc-household-structure-table'>
          <div className='ohc-household-structure-table-header'>
            <div className='ohc-household-structure-table-column-1'></div>
            <div className='ohc-household-structure-table-column-2'>
              <p>Current household</p>
            </div>
            <div className='ohc-household-structure-table-column-2'>
              <p>Proposed household</p>
            </div>
          </div>
          <Separator style={{margin:"16px 0"}} variant="solid"/>
          <div className='ohc-household-structure-table-content'>
            <div className='ohc-household-structure-table-column-1 ohc-household-structure-table-header'>
              <p>Owners</p>
            </div>
            <div className='ohc-household-structure-table-column-2'>
              { owners.length > 0 && owners.map((owner, __index)=>{
                  const key = "owner"+__index;
                  return <p key={key}>{owner.myinfo?.name}</p>
                })
              }
              { owners.length <= 0 && <p className='ohc-household-structure-table-placeholder'>You do not have any owner(s)</p>}
            </div>
            <div className='ohc-household-structure-table-column-2'>
              { incomingOwners.length > 0 && incomingOwners.map((incoming_owner, __index)=>{
                  const key = "incoming_owner"+__index;
                  return <p key={key}>{incoming_owner.myinfo?.name}</p>
                })
              }
              { incomingOwners.length <= 0 && <p className='ohc-household-structure-table-placeholder'>You have not added any owner(s)</p>}
            </div>
          </div>
          <Separator style={{margin:"16px 0"}}/>
          <div className='ohc-household-structure-table-content'>
            <div className='ohc-household-structure-table-column-1 ohc-household-structure-table-header'>
              <p>Occupiers</p>
            </div>
            <div className='ohc-household-structure-table-column-2'>
              { occupiers.length > 0 && occupiers.map((occupier,__index)=>{
                  const key = "occupier"+__index;
                  return <p key={key}>{occupier.myinfo?.name}</p>
                })
              }
              { occupiers.length <= 0 && <p className='ohc-household-structure-table-placeholder'>You do not have any occupier(s)</p>}
            </div>
            <div className='ohc-household-structure-table-column-2'>
              { incomingOccupiers.length > 0 && incomingOccupiers.map((incoming_occupier, __index)=>{
                  const key = "incoming_occupier"+__index;
                  return <p key={key}>{incoming_occupier.myinfo?.name}</p>
                })
              }
              { incomingOccupiers.length <= 0 && <p className='ohc-household-structure-table-placeholder'>You have not added any occupier(s)</p>}
            </div>
          </div>
          {hasExecutorAdministrator && <>
            <Separator style={{margin:"16px 0"}}/>
            <div className='ohc-household-structure-table-content'>
              <div className='ohc-household-structure-table-column-1 ohc-household-structure-table-header' style={{display:"block"}}>
                <p>Executor/</p>
                <p>Administrator</p>
              </div>
              <div className='ohc-household-structure-table-column-2'>
                { executorAdministratorListing.map((additional_role,__index)=>{
                    const key = "additional_role"+__index;
                    return <p key={key}>{additional_role.name} ({additional_role.role_name})</p>
                  })
                }
              </div>
            </div>
          </>}
        </div>}

      {isMobile && <>
        <MobileTableMobile title='Current household' items={current_mobile_table_items}/>
        <div style={{height:8}}></div>
        <MobileTableMobile title='Proposed household' items={proposed_mobile_table_items}/>
      </>}
      
    </div>
  )
}

export default HouseholdStructureTable